import React, { memo, useContext } from "react"
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch"
import Controls from "./Controls"
import { analysisContext } from "context/analysis-context"

function ImageAnnotation({ fields = [], image }) {
  const { selectedBox, changeSelectedBox } = useContext(analysisContext)
  return (
    <div className="border">
      <TransformWrapper>
        <Controls />
        <TransformComponent>
          <div className="position-relative d-inline-flex ">
            <img className="w-100 d-block rounded-3" src={image} alt="Image" />
            <svg className="position-absolute top-0 left-0 w-100 h-100">
              {fields.map((box, index) => {
                if (box.coordinates) {
                  const { x, y, width, height } = box.coordinates
                  const isHover = box.name === selectedBox.name

                  return (
                    <rect
                      key={index}
                      x={`${x * 100}%`}
                      y={`${y * 100}%`}
                      width={`${width * 100}%`}
                      height={`${height * 100}%`}
                      stroke="red"
                      fill={isHover ? "#dc35458c" : "transparent"}
                      opacity="50%"
                      strokeWidth="2"
                      onMouseEnter={() => changeSelectedBox(box)}
                      onMouseLeave={() => changeSelectedBox({})}
                    />
                  )
                }
              })}
            </svg>
          </div>
        </TransformComponent>
      </TransformWrapper>
    </div>
  )
}

export default memo(ImageAnnotation)
